import { Component, ChangeDetectionStrategy, Input } from '@angular/core';

@Component({
  selector: 'app-icon-surveys',
  templateUrl: './icon-surveys.component.html',
  styleUrls: ['./icon-surveys.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IconSurveysComponent {
  @Input() active = false;

  constructor() {}
}
